(() => {
  const page = document.querySelector('[data-collection-page]');
  if (!page) return;

  const filters = page.querySelector('[data-filters]');
  const overlay = page.querySelector('[data-filter-overlay]');
  const openBtn = page.querySelector('[data-filter-toggle]');
  const closeBtn = page.querySelector('[data-filter-close]');

  const open = () => {
    filters?.classList.add('is-open');
    openBtn?.setAttribute('aria-expanded', 'true');
    closeBtn?.focus();
    overlay?.classList.add('is-open');
    document.body.classList.add('pp-drawer-open');
  };
  const close = () => {
    filters?.classList.remove('is-open');
    openBtn?.setAttribute('aria-expanded', 'false');
    overlay?.classList.remove('is-open');
    document.body.classList.remove('pp-drawer-open');
  };

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', () => {close(); openBtn?.focus();});
  overlay?.addEventListener('click', () => {close(); openBtn?.focus();});
  document.addEventListener('keydown', event => {
    if (!filters?.classList.contains('is-open')) return;
    if (event.key === 'Escape') { close(); openBtn?.focus(); }
    if (event.key === 'Tab') {
      const items=[...filters.querySelectorAll('button,input,select,a,summary')].filter(el=>el.getClientRects().length && !el.disabled);
      const first=items[0],last=items[items.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  matchMedia('(min-width:990px)').addEventListener('change', close);

  const grid = page.querySelector('[data-collection-grid]');
  const initialColumns = grid?.style.getPropertyValue('--cols').trim();
  page.querySelectorAll('[data-grid-cols]').forEach(b => b.classList.toggle('is-active', b.dataset.gridCols === initialColumns));
  page.querySelectorAll('[data-grid-cols]').forEach(btn => {
    btn.addEventListener('click', () => {
      const cols = btn.dataset.gridCols;
      if (grid) grid.style.setProperty('--cols', cols);
      page.querySelectorAll('[data-grid-cols]').forEach(b => b.classList.toggle('is-active', b === btn));
      try { localStorage.setItem('ppGridCols', cols); } catch(e) {}
    });
  });

  try {
    const saved = localStorage.getItem('ppGridCols');
    if (['3','4'].includes(saved) && grid && !window.Shopify?.designMode) {
      grid.style.setProperty('--cols', saved);
      page.querySelectorAll('[data-grid-cols]').forEach(b => b.classList.toggle('is-active', b.dataset.gridCols === saved));
    }
  } catch(e) {}
})();
